export type AiProviderId = "gemini" | "openrouter" | "openai" | "openai-compatible";

export interface AiProviderPreset {
  id: AiProviderId;
  label: string;
  baseUrl: string;
  supportsFreeOnly: boolean;
}

export interface AiRuntimeSettings {
  enabled: boolean;
  primaryProvider: AiProviderId;
  primaryModel: string;
  primaryBaseUrl: string;
  fallbackEnabled: boolean;
  fallbackProvider: AiProviderId;
  fallbackModel: string;
  fallbackBaseUrl: string;
  freeOnly: boolean;
  primaryApiKeyConfigured: boolean;
  fallbackApiKeyConfigured: boolean;
}

export interface AiSettingsSaveInput {
  settings: Omit<AiRuntimeSettings, "primaryApiKeyConfigured" | "fallbackApiKeyConfigured">;
  primaryApiKey?: string;
  fallbackApiKey?: string;
}

export const AI_PROVIDER_PRESETS: readonly AiProviderPreset[] = [
  {
    id: "gemini",
    label: "Google Gemini",
    baseUrl: "https://generativelanguage.googleapis.com",
    supportsFreeOnly: true,
  },
  {
    id: "openrouter",
    label: "OpenRouter",
    baseUrl: "https://openrouter.ai/api/v1",
    supportsFreeOnly: true,
  },
  {
    id: "openai",
    label: "OpenAI",
    baseUrl: "https://api.openai.com/v1",
    supportsFreeOnly: false,
  },
  {
    id: "openai-compatible",
    label: "سرویس سفارشی سازگار با OpenAI",
    baseUrl: "",
    supportsFreeOnly: false,
  },
] as const;

export const DEFAULT_AI_RUNTIME_SETTINGS: AiRuntimeSettings = {
  enabled: false,
  primaryProvider: "gemini",
  primaryModel: "gemini-2.5-flash",
  primaryBaseUrl: "https://generativelanguage.googleapis.com",
  fallbackEnabled: true,
  fallbackProvider: "openrouter",
  fallbackModel: "openrouter/free",
  fallbackBaseUrl: "https://openrouter.ai/api/v1",
  freeOnly: true,
  primaryApiKeyConfigured: false,
  fallbackApiKeyConfigured: false,
};

export function providerPreset(id: AiProviderId): AiProviderPreset {
  const preset = AI_PROVIDER_PRESETS.find((item) => item.id === id);

  if (!preset) {
    throw new Error("AI_PROVIDER_UNKNOWN");
  }

  return preset;
}
